import { useQuery } from '@shared/modules/use-query/hooks'
import { AppointmentProductDetails } from '../types'
import { useCallback, useMemo } from 'react'
import { AppointmentsService } from '../services'
import { UseQueryOptions } from '@shared/modules/use-query/types'

export const useAppointmentProductDetails = (id: number | string) => {
  return useQuery<AppointmentProductDetails>(
    useCallback(async () => {
      const result = await AppointmentsService.getProductById(id)

      if (result.status === 200) {
        return result.data
      } else {
        throw new Error(result.data)
      }
    }, [id]),
    useMemo<UseQueryOptions>(
      () => ({
        initialData: null,
        enabled: !!id,
      }),
      [id],
    ),
  )
}
